import { render } from "./Voice.vue?vue&type=template&id=7d8fb9b6&scoped=true"
import script from "./Voice.vue?vue&type=script&lang=js"
export * from "./Voice.vue?vue&type=script&lang=js"

import "./Voice.vue?vue&type=style&index=0&id=7d8fb9b6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\User\\OneDrive\\工作案件\\前端管理介面\\vue3-adminlte3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d8fb9b6"]])

export default __exports__